import { render } from "./ServerError.vue?vue&type=template&id=2179299e&scoped=true"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"

import "./ServerError.vue?vue&type=style&index=0&id=2179299e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2179299e"]])

export default __exports__